import { Component } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'page-description-heading',
    templateUrl: './page-description-heading.component.html',
    styleUrls: ['./page-description-heading.component.less'],
})
export class PageDescriptionHeadingComponent {
    heading: SafeHtml;

    constructor(private sanitizer: DomSanitizer) {}

    setHeading(heading: string): void {
        this.heading = this.sanitizer.bypassSecurityTrustHtml(heading);
    }
}
